module.exports = __webpack_public_path__ + "img/profileDeclined.be0a7661.svg";